module.exports = __webpack_public_path__ + "static/media/(000102).c8d8ea0f.jpg";